<template lang="pug">
  .card(
    @mouseover="setGradientBackground(item)", @mouseout="setDefaultBackground(item)",
    :class="{ 'card--default' : !item.isHighlighted, 'card--highlighted' : item.isHighlighted, 'card--small' : item.isSmall }",
    @click="animateProduct()",
    ref="card"
  )
    .card__background(
      v-if="item.isHighlighted",
      :style="{'backgroundImage' : `linear-gradient(9.75deg, ${item.colorGradient} -6.68%, ${item.color} 94.55%, ${item.color} 94.55%)`, 'color' : item.colorShadow}", 
      ref="itemSmallBackground",
    )
    .card__background(
      v-if="!item.isSmall && !item.isHighlighted", 
      :style="{'backgroundImage' : `linear-gradient(38.45deg, ${item.color} 58.36%, ${item.colorGradient} 92.88%)`, 'color' : item.colorShadow}", 
      ref="itemSmallBackground",
    )
    .card__background(
      v-if="item.isSmall", 
      :style="{'backgroundImage' : `linear-gradient(218.07deg, ${item.color} 59.3%, ${item.colorGradient} 90.84%)`, 'color' : item.colorShadow}", 
      ref="itemSmallBackground",
    )
    h4.card__title
      .card__title-inner(ref="itemSmallTitle") {{ item.title }}
      .card__taste(v-if="item.isSmall") {{ item.taste }}
    .card__button(v-if="item.isHighlighted", ref="subtitle")
      .card__subtitle(:style="{'backgroundColor' : item.color }")
        span.card__subtitle-text {{ item.subtitle }}
      .card__subtitle-arrow
    .card__image-container
      img.card__image(:src="require(`@/assets/items/${item.image}`)", :alt="item.title", ref="itemSmallImage")
    .card__arrow
</template>

<script>
import { setTimeout } from "timers";
export default {
  name: "ItemCard",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    setGradientBackground(item) {
      const cardBackground = this.$refs.itemSmallBackground.style;
      if (!item.isHighlighted && !item.isSmall) {
        cardBackground.backgroundPosition = "center top";
      } else if (item.isSmall) {
        cardBackground.backgroundPosition = "center bottom";
      }
    },
    setDefaultBackground(item) {
      const cardBackground = this.$refs.itemSmallBackground.style;
      if (!item.isHighlighted && !item.isSmall) {
        cardBackground.backgroundPosition = "center bottom";
      } else if (item.isSmall) {
        cardBackground.backgroundPosition = "center top";
      }
    },
    transformElement(
      element,
      fullElement,
      currentProperties,
      futureProperties
    ) {
      let shiftTopFull = currentProperties.top - futureProperties.top;
      let shiftLeftFull = currentProperties.left - futureProperties.left;
      let scaleFull = currentProperties.height / futureProperties.height;

      const transform = `translate(${shiftLeftFull}px, ${shiftTopFull}px) scale(${scaleFull})`;

      fullElement.style.transform = transform;
      fullElement.style["-ms-transform"] = transform;
      fullElement.style["-o-transform"] = transform;
      fullElement.style["-webkit-transform"] = transform;

      fullElement.style.opacity = "1";
      if (!this.item.isHighlighted) {
        fullElement.style.color = "black";
      }
      element.style.opacity = "0";

      setTimeout(() => {
        const transition = "0.5s 0.2s ease-in-out";
        fullElement.style.transition = transition;
        fullElement.style["-ms-transition"] = transition;
        fullElement.style["-o-transition"] = transition;
        fullElement.style["-webkit-transition"] = transition;

        fullElement.style.transform = "none";
        fullElement.style["-ms-transform"] = "none";
        fullElement.style["-o-transform"] = "none";
        fullElement.style["-webkit-transform"] = "none";

        fullElement.style.color = "";
      }, 200);

      if (this.$refs.subtitle) {
        this.$refs.subtitle.style.opacity = "0";
      }

      setTimeout(() => {
        if (this.$refs.subtitle) {
          this.$refs.subtitle.style.opacity = "1";
        }
        element.style.opacity = "1";
      }, 1000);
    },
    setProperties(element, fullElementClass, popup) {
      let currentProperties = element.getBoundingClientRect();

      let fullElement;

      fullElement = document
        .getElementById(popup)
        .querySelector(`.${fullElementClass}`);

      let futureProperties = fullElement.getBoundingClientRect();

      this.transformElement(
        element,
        fullElement,
        currentProperties,
        futureProperties
      );
    },
    animateProduct() {
      if (window.innerWidth >= 1200) {
        const smallImage = this.$refs.itemSmallImage;
        const smallTitle = this.$refs.itemSmallTitle;
        const popupId = this.item.slug + "_popup";

        setTimeout(() => {
          this.setProperties(smallImage, "product__image", popupId);
          this.setProperties(smallTitle, "product__title-inner", popupId);
        }, 100);
      }
    }
  }
};
</script>

<style lang="scss">
@import "../styles/main.scss";

.card {
  $block: &;

  position: relative;
  z-index: 0;
  display: flex;
  align-items: center;
  width: 85%;
  margin: 25px auto 60px;

  @include from("xl") {
    margin: 0 auto 65px;
  }

  &__title,
  &__image-container,
  &__image,
  &__background,
  &__button,
  &__taste {
    pointer-events: none;
    touch-action: none;
  }

  &__title {
    font-family: $font-mojito;
    font-size: 65px;
    line-height: 0.8;
    margin: 0 auto 38px;
    font-weight: normal;
    position: relative;
    box-sizing: border-box;
    text-align: center;
    max-width: 250px;

    @include from("xxxl") {
      font-size: 75px;
    }
  }
  &__title-inner {
    transition: $card-title-transition;
    transform-origin: top left;
    display: inline-block;
    width: min-content;
  }
  &__image-container {
    text-align: center;

    @include from("xxxl") {
      width: 42%;
      max-height: 800px;
    }
  }
  &__image {
    max-height: 425px;
    transition: $card-image-transition;
    transform-origin: top left;

    @include from("lg") {
      max-height: 450px;
    }

    @include from("xxxl") {
      width: 100%;
      height: auto;
      max-height: none;
    }
  }
  &__background {
    width: 95%;
    position: absolute;
    content: "";
    top: 12%;
    left: 3%;
    z-index: -1;
    transition: $card-bg-transition;
    color: white;
    background-repeat: no-repeat;
    background-size: 100% 200%;
    background-position: center top;
    box-shadow: 0px 0px 70px;
    transform: scaleY(1.5);

    @include from("xl") {
      box-shadow: none;
      transform: scaleY(1);
    }
  }

  &:hover {
    #{$block}__background {
      @include from("xl") {
        box-shadow: 0px 0px 70px;
        transform: scaleY(1.5);
      }

      @include from("xxxl") {
        transform: scaleY(1.35);
      }
    }
  }

  &--default {
    text-align: center;
    flex-flow: column wrap;

    @include to("xl") {
      margin-bottom: 100px;
    }

    #{$block}__image {
      @include to("xl") {
        max-height: 350px;
      }
    }
    #{$block}__background {
      height: 67%;
      transform-origin: top;
      background-position: center top;

      @include from("xl") {
        background-position: center bottom;
      }

      @include from("xxxl") {
        height: 76%;
      }
    }

    #{$block}__arrow {
      position: absolute;
      width: 93%;
      overflow: hidden;
      height: 20px;
      margin: 0 auto 40px;
      bottom: -14%;

      &::after {
        content: url("../assets/card-arrow.svg");
        width: 196px;
        height: 20px;
        transition: $card-arrow-transition;
        position: absolute;

        @include to("xl") {
          opacity: 1;
          transform: translateX(-50%);
        }

        @include from("xl") {
          opacity: 0;
          transform: translateX(-200%);
        }
      }
    }

    &:hover {
      #{$block}__arrow {
        @include from("xl") {
          &:after {
            opacity: 1;
            transform: translateX(-50%);
          }
        }
      }
    }
  }

  &--highlighted {
    margin-bottom: 100px;
    width: 95%;

    @include from("lg") {
      width: 88%;
    }
    @include from("xxl") {
      margin-bottom: 150px;
    }

    #{$block}__background {
      background-size: 100% 100%;
      transform-origin: bottom;
      height: 400px;
      transform: scaleY(1.2);

      @include from("xl") {
        height: 430px;
        transform: scaleY(1);
        transform-origin: top;
      }
      @include from("xxl") {
        height: 502px;
      }
      @include from("xxxl") {
        height: 690px;
      }
    }
    #{$block}__title {
      transform: translateY(-100%);
      color: $color-text--contrast;

      @media screen and (min-width: 380px) {
        font-size: 75px;
      }

      @include from("xxxl") {
        font-size: 100px;
      }
    }

    #{$block}__button {
      position: absolute;
      width: 85%;
      left: -3%;
      top: 50%;
      overflow: hidden;

      #{$block}__subtitle {
        font-family: $font-carlito;
        font-size: 22px;
        line-height: 1;
        color: $color-text--contrast;
        padding: 23px 32px 23px 20px;
        box-sizing: border-box;
        text-align: left;
        min-height: 100px;
        transition: $card-button-transition;
        transform: translateX(0);

        @include from("lg") {
          font-size: 26px;
          padding: 23px 45px 23px 20px;
        }
        @include from("xl") {
          transform: translateX(100%);
        }

        @include from("xxxl") {
          font-size: 32px;
          padding: 32px 60px 32px 37px;
          min-height: 115px;
        }
      }

      #{$block}__subtitle-text {
        transition: $card-subtitle-transition;
        position: relative;
        opacity: 1;
        transform: translateX(0);
        left: 0;

        @include from("xl") {
          opacity: 0;
          left: 20%;
        }
      }

      #{$block}__subtitle-arrow {
        position: relative;
        left: 8%;
        overflow: hidden;

        &:after {
          display: block;
          content: "";
          background: url("../assets/arrow-small.svg") no-repeat;
          background-size: contain;
          width: 93px;
          height: 20px;
          margin: 15px 25px;
          transition: $card-arrow-transition;
          opacity: 1;
          transform: translateX(0);

          @media screen and (min-width: 380px) {
            margin: 15px 60px;
          }
          @include from("xl") {
            opacity: 0;
            transform: translateX(-200%);
          }
        }
      }

      @include from("md") {
        width: 70%;
      }
      @include from("xl") {
        padding-right: 32px;
      }
    }

    #{$block}__image-container {
      transform: translate(-15%, 0);

      @include from("xl") {
        transform: translate(-25%, 20%);
      }
    }

    &:hover {
      @include from("xl") {
        #{$block}__subtitle-arrow {
          &:after {
            opacity: 1;
            transform: translateX(0);
          }
        }
        #{$block}__subtitle-text {
          opacity: 1;
          transform: translateX(0);
          left: 0;
        }
        #{$block}__subtitle {
          transform: translateX(0);
        }
        #{$block}__background {
          transform: scaleY(1.2);
        }
      }
    }
  }
  &--small {
    #{$block}__title {
      font-size: 55px;
      padding-left: 0;

      @include from("xxxl") {
        font-size: 75px;
      }
    }
    #{$block}__taste {
      text-align: right;
      width: 82px;
      font-family: $font-carlito;
      color: #da2b1d;
      font-size: 20px;
      line-height: 1;
      font-weight: normal;
      text-indent: 0;
      display: none;
      position: absolute;

      @include from("sm") {
        display: block;
        transform: translate(-100%, -100%);
      }
      @include from("xxxl") {
        font-size: 25px;
        width: 105px;
      }
    }

    #{$block}__background {
      background-position: center bottom;

      @include from("xl") {
        background-position: center top;
      }
    }
  }
}

@include from("lg") {
  .col-xs-12:nth-of-type(even) {
    .card {
      &--default {
        flex-flow: column-reverse wrap;

        .card__title {
          margin: 38px auto 0;
        }
        .card__background {
          top: 24%;
          transform-origin: bottom;

          @include from("xxxl") {
            top: 16%;
          }
        }

        .card__arrow {
          top: -6%;
          bottom: auto;
        }
      }

      &--highlighted {
        .card__background {
          transform-origin: bottom;
        }
        .card__image-container {
          @include from("xl") {
            transform: translate(-25%, 0);
          }
        }
      }

      &--small {
        flex-flow: column wrap;

        .card__arrow {
          bottom: -14%;
          top: auto;
        }

        .card__title {
          margin: 0 auto 38px;
        }
        .card__taste {
          text-align: left;
          left: auto;
          bottom: auto;
          color: $color-text--contrast;

          @include from("xl") {
            right: 0;
            transform: translate(120%, -200%);
          }
        }
        .card__background {
          top: 12%;
          transform-origin: top;

          @include from("xxxl") {
            top: 10%;
          }
        }
      }
    }
  }

  .col-xs-12:nth-of-type(odd) {
    .card {
      &--small {
        .card__arrow {
          top: -6%;
          bottom: auto;
        }

        flex-flow: column-reverse wrap;

        .card__title {
          margin: 38px auto 0;
        }
        .card__background {
          top: 24%;
          transform-origin: bottom;

          @include from("xxxl") {
            top: 16%;
          }
        }
      }
    }
  }
}
</style>
